import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_MEASURES_REQUEST: '',
  GET_MEASURES_SUCCESS: '',
  GET_MEASURES_FAILURE: '',

  GET_MEMBER_MEASURES_REQUEST: '',
  GET_MEMBER_MEASURES_SUCCESS: '',
  GET_MEMBER_MEASURES_FAILURE: '',

  GET_MEASURE_MEMBERS_REQUEST: '',
  GET_MEASURE_MEMBERS_SUCCESS: '',
  GET_MEASURE_MEMBERS_FAILURE: '',

  GET_MEMBER_MEASURE_PRINT_FILE_REQUEST: '',
  GET_MEMBER_MEASURE_PRINT_FILE_SUCCESS: '',
  GET_MEMBER_MEASURE_PRINT_FILE_FAILURE: '',

  REFRESH_MEMBER_MEASURES_REQUEST: '',
  REFRESH_MEMBER_MEASURES_SUCCESS: '',
  REFRESH_MEMBER_MEASURES_FAILURE: '',

  GET_PROVIDER_OVERALL_PERFORMANCE_REQUEST: '',
  GET_PROVIDER_OVERALL_PERFORMANCE_SUCCESS: '',
  GET_PROVIDER_OVERALL_PERFORMANCE_FAILURE: '',
};

types = setStoreTypeValues(types, 'eligibilityMeasures');

export default types;
